<template>
  <BaseModal
    title="Archive session"
    description="Confirm that you want to proceed."
    :is-open="showArchiveSessionModal"
    @close="showArchiveSessionModal = false"
  >
    Are you sure you want to archive '{{ pi_session.name }}'?

    <ul>
      <li>Archived sessions do not sync with your ALM tool anymore</li>
      <li>Archived sessions can be unarchived at any time</li>
    </ul>
    <template #actions>
      <BaseButton variant="ghost" color="grey" @click="showArchiveSessionModal = false">
        Cancel
      </BaseButton>
      <FeedbackButton success-message="Archived successfully." @click="archiveSession">
        Archive
      </FeedbackButton>
    </template>
  </BaseModal>
</template>

<script>
import { mapState } from "pinia";

import BaseButton from "@/components-ng/BaseButton.vue";
import BaseModal from "@/components-ng/BaseModal.vue";
import FeedbackButton from "@/components-ng/FeedbackButton.vue";
import serverCaller from "@/components/ServerCaller.vue";
import SessionHandler from "@/handlers/sessionHandler";
import { useAppStore } from "@/stores";
import { createHandlerContext } from "@/stores/context";

export default {
  name: "ArchiveSessionModal",
  components: { FeedbackButton, BaseModal, BaseButton },
  mixins: [serverCaller],
  props: {
    sessionId: { type: String, default: "" },
  },
  emits: ["changed"],
  data() {
    return {
      pi_session: { name: "" },
      message: {
        text: "",
        type: "success",
      },
      showArchiveSessionModal: false,
    };
  },
  computed: {
    ...mapState(useAppStore, ["company", "session"]),
    sessionHandler() {
      return new SessionHandler(createHandlerContext(), this.sessionId);
    },
  },
  methods: {
    show(session) {
      this.pi_session = session;
      this.showArchiveSessionModal = true;
    },
    async archiveSession() {
      this.message.text = "";
      try {
        const response = await this.sessionHandler.archiveSession(this.pi_session.session_id);
        this.showArchiveSessionModal = false;
        this.$emit("changed");
        return response;
      } catch (error) {
        throw new Error("Could not archive the session", { cause: error });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
ul {
  margin: 12px 0;
  padding-left: 20px;
  list-style-type: disc;
  line-height: 1.5;
}
</style>
